<div class="row ss-top-menu">
	<div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-9">
		<span class="ss-text-dark">Metrics <i class="rightArrow fa fa-angle-right"></i></span>
    <span class="ss-text-dark">MKW Business Head Metrics</span>
  </div>
</div>

<div class="container-set mt-2 filterRow">
	<div class="row mx-0">
		<div class="col-sm-11">
			<div class="row  mx-0" style="">
				<ul class="nav tabs-chng ml-3 mt-1 mb-1">
					<!-- <li class="nav-item itm-chng mr-4" id="city">
						<span class="rk-form-fontsize font-weight-bold">Select City</span>
				  	<angular2-multiselect [data]="city_dropdownList" [(ngModel)]="selectedCityItems"
				    [settings]="city_dropdownSettings"
				    (onSelect)="onItemSelect($event,'city',0)"
				    (onDeSelect)="OnItemDeSelect($event,'city',0)"
				    (onSelectAll)="onSelectAll($event)"
				    (onDeSelectAll)="onDeSelectAll($event)"></angular2-multiselect>

				  </li> -->
				  <li class="nav-item itm-chng mr-2">
					<span class="rk-form-fontsize font-weight-bold">Select City</span>
					<angular2-multiselect [data]="city_dropdownList" [(ngModel)]="selectedCityItems"
				  [settings]="city_dropdownSettings"
				  (onSelect)="onItemSelect($event,'city',0)"
				  (onDeSelect)="OnItemDeSelect($event,'city',0)"
				  (onSelectAll)="onSelectAll($event)"
				  (onDeSelectAll)="onDeSelectAll($event)"></angular2-multiselect>

				</li>
				  <li  class="nav-item itm-chng mr-4 selecteditems">
				  	<span class="rk-form-fontsize font-weight-bold">Select CM</span>
				  	<angular2-multiselect [data]="cm_dropdownList" [(ngModel)]="selectedCmItems"
				    [settings]="cm_dropdownSettings" class="selectedCmItems"
				    (onSelect)="onItemSelect($event,'cm',1)"
				    (onDeSelect)="OnItemDeSelect($event,'cm',1)"
				    (onSelectAll)="onSelectAll($event)"
				    (onDeSelectAll)="onDeSelectAll($event)"></angular2-multiselect>

				  </li>
				  <li  class="nav-item itm-chng mr-4 selectdesigner">
				  	<span class="rk-form-fontsize font-weight-bold">Select Designer</span>
				  	<angular2-multiselect [data]="designer_dropdownList" [(ngModel)]="selectedDesignerItems"
				    [settings]="designer_dropdownSettings"
				    (onSelect)="onItemSelect($event,'designer',2)"
				    (onDeSelect)="OnItemDeSelect($event,'designer',2)"
				    (onSelectAll)="onSelectAll($event)"
				    (onDeSelectAll)="onDeSelectAll($event)"></angular2-multiselect>
				  </li>
					<li class="nav-item mr-4" style="">
						<span class="rk-form-fontsize font-weight-bold">Select Date Type</span>
					    <angular2-multiselect [data]="datetype_dropdownList" [(ngModel)]="selectedDatetypeItems"
					    [settings]="datetype_dropdownSettings"
					    (onSelect)="onItemSelect($event,'datetype',3)"
					    (onDeSelect)="OnItemDeSelect($event,'datetype',3)"
					    (onSelectAll)="onSelectAll($event)"
					    (onDeSelectAll)="onDeSelectAll($event)"></angular2-multiselect>
					</li>

					<li  class="nav-item itm-chng mr-4 " id="fromDateLi">
				  		<span class="fromDateSpan rk-form-fontsize font-weight-bold">From Date </span>
	        		<input [owlDateTime]="dt1" [owlDateTimeTrigger]="dt1" placeholder="From Date"  class="px-2 rk-form-fontsize d-block rounded py-1 border" [(ngModel)]="from_date">
              <owl-date-time #dt1 [pickerType]="'calendar'"></owl-date-time> 
					</li>

					<li class="nav-item itm-chng "  id="toDateLi">
				  		<span class="toDateSpan  rk-form-fontsize font-weight-bold " >To Date </span>
				  		<input [owlDateTime]="dt2" [owlDateTimeTrigger]="dt2" placeholder="To Date"  class=" rk-form-fontsize d-block px-2 rounded py-1 border" [(ngModel)]="to_date" [min]="from_date">
              <owl-date-time #dt2 [pickerType]="'calendar'" ></owl-date-time>
					</li>
				</ul>
			</div>
		</div>
		<div class="col-sm-1 text-center pt-2">
			 <img src="assets/img/dashboard/submit.png" class="ml-1 filterRowIcon sendicon addCursor" (click)="filterData()">
		</div>
	</div>
</div>

<div class="row card-row1 mt-3" *ngIf="metricdata">
	<div class="col-3">
		<div class="card text-center  border-0 rounded-0 bg-white">
	    <p class="count-heading mt-3">{{metricdata.avg_days_assign_designer}} Days</p>
	    <p class="mt-1 count-text px-3">Average Number of days taken to assign a Designer from Qualification Date</p>
		</div>
	</div>
	<div class="col-3">
		<div class="card text-center  border-0 rounded-0 bg-white">
	    <p class="count-heading mt-3">{{metricdata.avg_days_designer_first_attempt}} Days</p>
	    <p class="mt-1 count-text px-3">Average Number of Days for First Attempt by a Designer</p>
		</div>
	</div>
	<div class="col-3">
		<div class="card text-center  border-0 rounded-0 bg-white">
    	<p class="count-heading mt-3">{{metricdata.percent_designer_assigned_24h}}%</p>
	    <p class="count-text px-3">% of Cases where Designer was assigned before 24 hours</p>
		</div>
	</div>
	<div class="col-3">
		<div class="card text-center  border-0 rounded-0 bg-white">
    	<p class="count-heading mt-3">{{metricdata.percent_attempts_after_24h}}%</p>
	    <p class="count-text px-3">% of first attempt in 24 hours</p>
		</div>
	</div>
</div>

<div class="row card-row2 mt-4" *ngIf="metricdata">
	<div class="col-2"></div>
	<div class=" col-8 px-5">
		<table width="100%">
			<thead>
				<tr>
					<th>Metrics</th>
					<th class="text-center">Target</th>
					<th class="text-center">Actual</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td class="font-weight-bold">Number of Home Visits</td>
					<td class="text-center">{{metricdata.home_visits_target}}</td>
					<td class="text-center">{{metricdata.home_visits}}</td>
				</tr>
				<tr>
					<td class="font-weight-bold">Number of EC Visits</td>
					<td class="text-center">{{metricdata.ec_visits_target}}</td>
					<td class="text-center">{{metricdata.ec_visits}}</td>
				</tr>
				<tr>
					<td class="font-weight-bold">Number of BOQs Shared</td>
					<td class="text-center">{{metricdata.boq_shared_target}}</td>
					<td class="text-center">{{metricdata.boq_shared}}</td>
				</tr>
				<tr>
					<td class="font-weight-bold">Value of BOQs Shared</td>
					<td class="text-center"><span *ngIf="metricdata.value_boq_shared_target!='NA'">&#8377; </span>{{metricdata.value_boq_shared_target}}</td>
					<td class="text-center">&#8377; {{metricdata.value_boq_shared}}</td>
				</tr>
				<tr>
					<td class="font-weight-bold">10% Payment Collected</td>
					<td class="text-center"><span *ngIf="metricdata.percent_10_payment_target!='NA'">&#8377; </span>{{metricdata.percent_10_payment_target}}</td>
					<td class="text-center">&#8377; {{metricdata.percent_10_payment}}</td>
				</tr>
				<tr>
					<td class="font-weight-bold">40% Payment Collected</td>
					<td class="text-center"><span *ngIf="metricdata.percent_40_payment_target!='NA'">&#8377;</span> {{metricdata.percent_40_payment_target}}</td>
					<td class="text-center">&#8377; {{metricdata.percent_40_payment}}</td>
				</tr>
				<tr>
					<td class="font-weight-bold">Tasks done within Timeline</td>
					<td class="text-center">{{metricdata.tasks_done_in_timeline_target}}</td>
					<td class="text-center">{{metricdata.tasks_done_in_timeline}}</td>
				</tr>
				<tr>
					<td class="font-weight-bold">New Display Dealers Added</td>
					<td class="text-center">{{metricdata.new_display_dealers_target}}</td>
					<td class="text-center">{{metricdata.new_display_dealers}}</td>
				</tr>
				<tr>
					<td class="font-weight-bold">New Non-Display Dealers Added</td>
					<td class="text-center">{{metricdata.new_non_display_dealers_target}}</td>
					<td class="text-center">{{metricdata.new_non_display_dealers}}</td>
				</tr>
				<tr>
					<td class="font-weight-bold">Leads from Display Dealers</td>
					<td class="text-center">{{metricdata.leads_display_dealers_target}}</td>
					<td class="text-center">{{metricdata.leads_display_dealers}}</td>
				</tr>
				<tr>
					<td class="font-weight-bold">Leads from Non-Display Dealers</td>
					<td class="text-center">{{metricdata.leads_non_display_dealers_target}}</td>
					<td class="text-center">{{metricdata.leads_non_display_dealers}}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>

<div class="row card-row3 mt-4 mx-0" *ngIf="metricdata">
	<div class="col-12 mb-3 mt-4 text-center">
		<button class="button1 py-1 px-3 addCursor mr-5" [ngClass]="{'active-btn':is_lastweektrend_flag}" (click)="toggleWeekFlag(true); filterData()">Last Weeks Trends</button>
		<button class="button1 py-1 px-3 addCursor" [ngClass]="{'active-btn':!is_lastweektrend_flag}" (click)="toggleWeekFlag(false)" data-toggle="modal" data-target="#showpastdatacalendarmodal">Show Data for Past Weeks</button>
	</div>
	<div class="col-12 mt-3 px-4">
		<table width="100%">
			<thead>
				<tr>
					<th>BOQ Creation Date</th>
					<th *ngFor="let acqdates of metricdata.boq_creation_date_array" class="text-center">{{acqdates.date}}</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Number of BOQs</td>
					<td *ngFor="let acqdates of metricdata.boq_creation_date_array" class="text-center">{{acqdates.total}}</td>
				</tr>
				<tr>
					<td>Value of BOQs</td>
					<td *ngFor="let acqdates of metricdata.boq_creation_date_array" class="text-center">&#8377; {{acqdates.value}}</td>
				</tr>
				<tr>
					<td>Target Number of BOQs </td>
					<td *ngFor="let acqdates of metricdata.boq_creation_date_array" class="text-center">{{acqdates.target_total}}</td>
				</tr>
				<tr>
					<td>Target Value of BOQs</td>
					<td *ngFor="let acqdates of metricdata.boq_creation_date_array" class="text-center"><span *ngIf="acqdates.target_value!='NA'">&#8377;</span> {{acqdates.target_value}}</td>
				</tr>
			</tbody>
		</table>
	</div>
	<div class="col-12 mt-4 mb-4 px-4">
		<table width="100%">
			<thead>
				<tr>
					<th>BOQ Sharing Date</th>
					<th *ngFor="let acqdates1 of metricdata.boq_sharing_date_array" class="text-center">{{acqdates1.date}}</th>
				</tr>
			</thead>
			<tbody>
				<tr>
					<td>Number of BOQs</td>
					<td *ngFor="let acqdates1 of metricdata.boq_sharing_date_array" class="text-center">{{acqdates1.total}}</td>
				</tr>
				<tr>
					<td>Value of BOQs</td>
					<td *ngFor="let acqdates1 of metricdata.boq_sharing_date_array" class="text-center">&#8377; {{acqdates1.value}}</td>
				</tr>
				<tr>
					<td>Target Number of BOQs</td>
					<td *ngFor="let acqdates1 of metricdata.boq_sharing_date_array" class="text-center">{{acqdates1.target_total}}</td>
				</tr>
				<tr>
					<td>Target Value of BOQs</td>
					<td *ngFor="let acqdates1 of metricdata.boq_sharing_date_array" class="text-center"><span *ngIf="acqdates1.target_value!='NA'">&#8377;</span> {{acqdates1.target_value}}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>

<div class="modal" id="showpastdatacalendarmodal" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="text-right">
        <button type="button" class="close mx-3 my-2" data-dismiss="modal" (click)="week_from_date=null; is_lastweektrend_flag=true;">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
      	<div class="row">
          <div class="col-4 pr-0">
          	<span class=" rk-form-fontsize " style="font-weight: 500">Choose From Date </span>
          </div>
          <div class="col-6 px-0">
          	<input [owlDateTime]="dt3" [owlDateTimeTrigger]="dt3" placeholder="From Date"  class=" rk-form-fontsize  form-control" [(ngModel)]="week_from_date">
          	<owl-date-time #dt3 [pickerType]="'calendar'" ></owl-date-time>
          </div>
          <div class="mt-3 text-right col-12">
          	<button (click)="filterData()" class="rk-interalBtnColor addCursor" data-dismiss="modal">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/platform/organisation/metrics/mkwbusinesshead-metric/mkwbusinesshead-metric.component.html